import { render, staticRenderFns } from "./SystemCreatePanel.vue?vue&type=template&id=4a5d1942&"
import script from "./SystemCreatePanel.vue?vue&type=script&lang=js&"
export * from "./SystemCreatePanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports